import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import {
    Box, Divider, Typography, Container, Paper, Grid, FormControl, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';

import {
    DataGrid,
} from '@mui/x-data-grid';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import useWindowDimensions from '../../utils/functions/useWindowDimensions';

const Categorias = (props) => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({});
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [value, setValue] = useState('');
    const [category, setCategory] = useState([]);
    const [currentCategory, setCurrentCategory] = useState({});
    const [modalEditCategory, setModalEditCategory] = useState(false);
    const [modalDeleteCategory, setModalDeleteCategory] = useState(false);
    const [loading, setLoading] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });
    const { height } = useWindowDimensions();

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Editar Categorias';
    }, [auth])

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setData(res.data);
                const tmpCategories = res.data.categorias.map((x) => {
                    return {
                        nombre: x.nombre,
                        descripcion: x.descripcion,
                        value: x.value,
                        uuid: getUuid()
                    }
                })
                setCategory(tmpCategories);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    // categorias

    const getUuid = () => { return uuidv4() };

    const handleAddCategory = (e, x) => {
        e.preventDefault();
        x.uuid = getUuid();
        if (x.nombre) {
            setCategory(category => [...category, {
                nombre: x.nombre,
                descripcion: x.descripcion,
                value: x.value,
                uuid: x.uuid
            }]);
        }
        else {
            setCategory(category => [...category, {
                descripcion: x.descripcion,
                value: x.value,
                uuid: x.uuid
            }]);
        }
        setNombre('');
        setDescripcion('');
        setValue('');
    }

    const handleUpdateCategory = (d, e) => {
        setModalEditCategory(false);
        let tmp = {}
        tmp.uuid = e;
        if (d.nombre)
            if (d.nombre !== '')
                tmp.nombre = d.nombre;
        if (d.descripcion)
            tmp.descripcion = d.descripcion;
        if (d.value)
            tmp.value = d.value;
        setCategory(category.map(r => r.uuid === e ? tmp : r));
    }

    const handleCloseEditCategory = () => {
        setModalEditCategory(false);
        setCurrentCategory({ nombre: '', descripcion: '', value: '' });
    }

    const handleCloseDeleteCategory = () => {
        setModalDeleteCategory(false);
        setCurrentCategory({ nombre: '', descripcion: '', value });
    }

    const handleEditCategory = (d) => {
        setCurrentCategory(d);
        setModalEditCategory(true);
    }

    const renderEditCategory = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEditCategory}
                scroll='paper'
                onClose={handleCloseEditCategory}>
                <DialogTitle >Editar Categoría</DialogTitle>
                <DialogContent>
                    {currentCategory ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Nombre" variant="outlined" value={currentCategory.nombre} onChange={(e) => setCurrentCategory({ ...currentCategory, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" variant="outlined" value={currentCategory.descripcion} onChange={(e) => setCurrentCategory({ ...currentCategory, descripcion: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Key word" variant="outlined" value={currentCategory.value} onChange={(e) => setCurrentCategory({ ...currentCategory, value: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateCategory(currentCategory, currentCategory.uuid)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEditCategory()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleBeforeDeleteCategory = (d) => {
        setCurrentCategory(d);
        setModalDeleteCategory(true);
    }

    const handleDeleteCategory = (d, r) => {
        if (r < 2) {
            setCategory([]);
        } else {
            setCategory(category.filter(x => x.uuid !== d)); // filter pie array to remove the one with the key
        }
        handleCloseDeleteCategory();
    }

    const renderDeleteCategory = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalDeleteCategory}
                scroll='paper'
                onClose={handleCloseDeleteCategory}>
                <DialogTitle >Eliminar Categoría</DialogTitle>
                <DialogContent>
                    <Typography variant='body1' sx={{ mb: 2 }}>¿Está seguro de eliminar la categoría?</Typography>
                    <Typography variant='body1'>Nombre: <span style={{ fontWeight: 700 }}> {currentCategory.nombre}</span></Typography>
                    <Typography variant='body1'>Descripción: <span style={{ fontWeight: 700 }}>{currentCategory.descripcion}</span></Typography>
                    <Typography variant='body1'>Key word: <span style={{ fontWeight: 700 }}>{currentCategory.value}</span></Typography>
                    <Button variant='contained' disabled={loading} color='error' onClick={() => handleDeleteCategory(currentCategory.uuid, category.length)} style={{ marginTop: '24px' }}>Eliminar &nbsp; <i className="fad fa-delete"></i></Button>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseDeleteCategory()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleUpdateCategories = async (e) => {
        e.preventDefault();

        const tmp = category.map((x) => {
            return {
                nombre: x.nombre,
                descripcion: x.descripcion,
                value: x.value
            }
        });

        let config = data;
        config.categorias = tmp;

        try {
            const res = await axios.post(`/api/configs/${data._id}`, { config: config });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Se actualizaron las categorias', severity: 'success' } });
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al editar las categorias, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                <Container maxWidth='xxl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Editar Categorias</Typography>
                    </Box>
                    <Container maxWidth='xl'>
                        <Button size='small' variant='outlined' onClick={() => navigate('/config')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    </Container>

                    <Divider className='my-3' textAlign="center">
                        <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Categorías' className='text-bold' />
                    </Divider>

                    <div>
                        <Grid container spacing={1} className='my-1' sx={{ border: '0.5px solid #ccc', borderRadius: '20px', padding: '10px 4px' }}>
                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>Nombre</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>Descripción</Typography>
                            </Grid>
                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>Key word</Typography>
                            </Grid>
                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>Editar</Typography>
                            </Grid>
                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>Eliminar</Typography>
                            </Grid>
                        </Grid>
                        {category.map((n, i) => (
                            <Grid container spacing={1} key={i} className='my-1' sx={{ border: '0.5px solid #ddd', borderRadius: '20px', padding: '10px 4px' }}>
                                <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography fontWeight={700}>{category[i].nombre}</Typography>
                                </Grid>
                                <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography sx={{ textAlign: 'center' }}>{category[i].descripcion}</Typography>
                                </Grid>
                                <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography>{category[i].value}</Typography>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Button variant='outlined' color='primary' onClick={() => handleEditCategory(category[i])}>Editar &nbsp;<i className='fad fa-edit'></i></Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Button variant='outlined' color='error' onClick={() => handleBeforeDeleteCategory(category[i])}>Eliminar &nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        ))}
                    </div>
                    <form onSubmit={(e) => handleAddCategory(e, { nombre: nombre, descripcion: descripcion, value: value })}>
                        <Grid container spacing={3} className='my-2'>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField required label="Categoría" variant="outlined" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField required label="Descripción" variant="outlined" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                                </FormControl>
                            </Grid><Grid item xs={12} md={3}>
                                <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField required label="Key word" variant="outlined" value={value} onChange={(e) => setValue(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button variant='outlined' size='large' color='primary' type='submit'>Agregar categoría &nbsp; <i className="fad fa-plus-circle"></i></Button>
                            </Grid>
                        </Grid>
                    </form>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} sx={{ my: 2, display: 'flex', justifyContent: 'end' }}>
                            <Button variant="contained" onClick={(e) => handleUpdateCategories(e)} color="success" disabled={loading}>Actualizar Categorias&nbsp; <i className="fad fa-upload"></i></Button>
                        </Grid>
                    </Grid>

                    {renderEditCategory()}
                    {renderDeleteCategory()}

                </Container>

                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}
export default Categorias